define('views/linkedaccounts/edit',[
	"backbone",
	"views/_base/baseview",
	"text!views/linkedaccounts/edit.html",
	"models/linkedcards/linkedcard",
	"views/shared/button/button",
], function (Backbone, BaseView, Template, LinkedCardModel, ButtonComponent) {
	"use strict";

	return BaseView.extend({
		className: "linked-accounts-card-edit-form-inner-container",
		tagName: "span",
		isRender: true,
		template: _.template(Template),
		events: {
			"click .js-linked-account-edit-form-save": "saveAccountInfo",
			"click .js-linked-account-edit-form-cancel": "closeEditForm",
		},
		initialize: function (options) {
			options = options || {};

			this.data = options.card;
			this.card_view = options.card_view;

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this;

			this.$el.html(this.template());

			this.checkDefaultStatus();

			this.$(".js-linked-accounts-card-edit-form-buttons").attr("id", this.card_view.card_id);

			// this.addEditButton();

			setTimeout(function () {
				that.addEditButton();
			}, 300);

			return this;
		},

		loadData: function () {},

		checkDefaultStatus: function () {
			if (this.data.IsDefault) {
				this.$(".js-linkedcard-default").attr("checked", true);
			}
		},

		addEditButton: function () {
			this.edit_card_button = new ButtonComponent({
				// General
				elementName: "#card-" + this.data.Identifier,
				calling_view: this,
				render_in_parent: true,
				// Transactional
				is_transaction: false,
				// Default
				btn_label: "Save",
				btn_callback: this.saveAccountInfo,
				btn_retry_callback: this.saveAccountInfo,
				// Confirm
				btn_confirm: false,
				// Cancel
				btn_cancel: true,
				btn_cancel_label: "Cancel",
				btn_cancel_callback: this.cancelEditCard,
				// Success
				btn_success: true,
				btn_success_delay: 700,
				btn_success_label: "OK",
				btn_success_message: "Changes saved",
				btn_success_callback: this.editCardSuccess,
				// Error
				btn_error: true,
				btn_error_delay: 700,
				btn_error_label: "Retry",
				btn_error_cancel_label: "Cancel",
				btn_error_message: "Could not saved changes",
				btn_error_callback: this.canceledEditCardOnError,
			});
		},

		cancelEditCard: function (that) {
			var that = that ? that : this;
			that.closeEditForm({ render: false });
		},

		editCardSuccess: function (resetButton) {
			var that = that ? that : this;

			if (resetButton.name) {
				that.edit_card_button[resetButton.name]();
			} else {
				resetButton(that.edit_card_button);
			}

			setTimeout(function () {
				that.closeEditForm({ render: true, isModal: false });
			}, 700);
		},

		canceledEditCardOnError: function () {
			// console.log('canceledEditCardOnError');
		},

		saveAccountInfo: function (processComplete, that) {
			var that = that ? that : this,
				card_name = that.$el.find(".js-linkedcard-name").val(),
				is_default = that.$el.find(".js-linkedcard-default").is(":checked"),
				data = {
					ID: is_default,
					LGUID: that.data.LinkedCardGUID,
				};

			if (card_name && card_name != "") {
				data.NN = card_name;
			} else {
				data.NN = that.data.NickName;
			}

			var linked_card = new LinkedCardModel(data);

			$.ajax({
				url: pf.consumerURL + "/LinkedCards",
				type: "PUT",
				data: JSON.stringify(linked_card),
				contentType: "application/json",
				success: function (model, resp) {
					if (processComplete.name) {
						that.edit_card_button[processComplete.name](true);
					} else {
						processComplete(true, that.edit_card_button);
					}
				},
				error: function (model, resp) {
					if (processComplete.name) {
						that.edit_card_button[processComplete.name](false);
					} else {
						processComplete(false, that.edit_card_button);
					}
				},
			});

			return that;
		},

		closeEditForm: function (updates) {
			this.card_view.closeEditForm(updates);
			return false;
		},

		close: function () {},
	});
});

